import { InjectionToken } from '@angular/core';
import type { IOrgUnitsDataService } from './org-units-data-service.interface';

/**
 * Injection token for providing OU tree data to the OU tree picker matcher.
 *
 * Usage in app module/component providers:
 * ```typescript
 * { provide: OU_TREE_DATA_PROVIDER, useExisting: OrgUnitsDataService }
 * ```
 */
export const OU_TREE_DATA_PROVIDER = new InjectionToken<IOrgUnitsDataService>(
  'OU_TREE_DATA_PROVIDER'
);
